import { createRoutine } from 'redux-saga-routines'
import moment from 'moment-timezone'

import { IAuthState } from './index.interface'

export const saveToken = createRoutine('TOKEN')
export const updateToken = createRoutine('UPDATE_TOKEN')
export const refreshAccessToken = createRoutine('REFRESH_TOKEN')

const initialAuthState: IAuthState = {
  loading: false,
  error: false,
  success: false,
  message: '',
  token: '',
  expiryTime: null,
  refreshToken: ''
}

export default (state = initialAuthState, action: any) => {
  const { type = '', payload = {} as Partial<IAuthState> } = action
  switch (type) {
    case saveToken.SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
        success: true,
        token: payload.token,
        expiryTime: moment().add(60, 'minutes').unix(),
        refreshToken: payload.token,
        intervalId: payload.intervalId
      }

    case updateToken.SUCCESS:
      return Object.assign({}, {
        ...state,
        error: false,
        loading: false,
        success: true
      }, payload)

    default:
      return { ...state }
  }
}
